
import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class MessageDialog extends Vue {
  connectCodeList: number[] = [];
  input = "";
  canDown = false;
  secend = 15; //每多少秒新开窗口
  getConnectCodeList() {
    if (this.input.indexOf("，") !== -1) {
      this.$message.warning(
        "注意！你的输入有中文逗号，请检查并替换为英文逗号,"
      );
      return;
    }
    if (this.input[this.input.length - 1] === ",") {
      this.input = this.input.slice(0, this.input.length - 1);
    }
    this.connectCodeList = this.input.split(",").map(item => {
      return parseInt(item);
    });
  }
  check() {
    this.getConnectCodeList();
    if (this.connectCodeList.length === 0) {
      this.$message.error("请输入connectCode");
      this.canDown = false;
      return;
    }

    if (this.connectCodeList.some(item => isNaN(item))) {
      this.canDown = false;
      this.$message.error("connectCode必须是数字");
      return;
    }
    if (this.connectCodeList.some(item => item.toString().length !== 11)) {
      this.canDown = false;
      this.$message.error("connectCode必须是11位数字");
      return;
    }
    this.$message.success("connectCode合法,可以开始下载");
    this.getWorkerList();
    this.canDown = true;
  }
  maxLine = 4;
  maxLineLength = 0;
  workerList: number[][] = [[]];
  getWorkerList() {
    this.workerList = [[]];
    const baseLength = Math.floor(this.connectCodeList.length / this.maxLine);
    console.log("baseLength");
    console.log(baseLength);
    for (let i = 0; i < this.maxLine; i++) {
      if (i === this.maxLine - 1) {
        this.workerList[i] = this.connectCodeList.slice(
          i * baseLength,
          this.connectCodeList.length
        );
      } else {
        this.workerList[i] = this.connectCodeList.slice(
          i * baseLength,
          (i + 1) * baseLength
        );
      }
    }
    console.log(this.workerList);
    this.maxLineLength = this.workerList.reduce((pre, cur) => {
      return pre > cur.length ? pre : cur.length;
    }, 0);
    console.log("this.maxLineLength" + this.maxLineLength);
  }
  timer: any = 0;
  down() {
    if (this.timer) return;
    this.$message.success("开始下载,请勿关闭浏览器窗口");
    this.canDown = false;
    let index = 0;
    //立即
    this.runWorkerList(index);
    index++;
    this.timer = setInterval(() => {
      this.runWorkerList(index);
      index++;
      if (index === this.maxLineLength) {
        clearInterval(this.timer);
        this.timer = 0;
        this.$message.success("下载全部完成");
      }
    }, this.secend * 1000);
  }
  runWorkerList(index: number) {
    for (let i = 0; i < this.workerList.length; i++) {
      if (this.workerList[i][index]) {
        this.open(this.workerList[i][index]);
      }
    }
  }
  open(connectCode: number) {
    const url = `/candidate-info?connectCode=${connectCode}&autoDownload=1`;
    window.open(url, "_blank");
  }
}
